import { render, staticRenderFns } from "./expandText.vue?vue&type=template&id=6e07fc10&"
import script from "./expandText.vue?vue&type=script&lang=js&"
export * from "./expandText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports